module.exports = __webpack_public_path__ + "static/media/slack.4ac3fa2a.svg";